import i18n from "@/i18n";

const routes = {
  path: "/event",
  name: "Event",
  component: () => import(/* webpackChunkName: "event" */ "@/views/event/Main"),
  children: [
    {
      path: "minigamelist",
      alias: "",
      name: "MiniGameList",
      component: () =>
        import(/* webpackChunkName: "event" */ "@/views/event/MiniGameList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_list"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_list")],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/event/minigamelist",
      },
    },
    {
      path: "minigamewrite",
      name: "MiniGameWrite",
      component: () =>
        import(/* webpackChunkName: "event" */ "@/views/event/MiniGameWrite"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_write"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_list")],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/event/minigamelist",
      },
    },
    {
      path: "minigamewrite/:eventno+",
      name: "MiniGameModify",
      component: () =>
        import(/* webpackChunkName: "event" */ "@/views/event/MiniGameWrite"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_edit"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_list")],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/event/minigamelist",
      },
    },
    {
      path: "minigamerank/:eventno+",
      name: "MiniGameRank",
      component: () =>
        import(/* webpackChunkName: "event" */ "@/views/event/EventRank"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_rank"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_list")],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/event/minigamelist",
      },
    },
    {
      path: "winningdetaillist/:eventno+",
      name: "WinningDetailList",
      component: () =>
        import(
          /* webpackChunkName: "event" */ "@/views/event/WinningDetailList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_list"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_list")],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/event/minigamelist",
      },
    },
    {
      path: "winninglist",
      name: "MiniGameWinningList",
      component: () =>
        import(
          /* webpackChunkName: "event" */ "@/views/event/MiniGameWinningList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_win"),
        step: [i18n.t("page.event.event"), i18n.t("page.event.minigame_win")],
        menu_num: 5,
        sub_menu_num: 52,
        location: "/event/winninglist",
      },
    },
  ],
};

export default routes;
